import { compact, trim } from 'lodash'
import { BASE_URL } from 'config'
import { synapse } from 'state'
import { addNotification } from 'components/Notifications/actions'
import { saveAutomatedPanelInfo } from 'pages/InputView/helpers/saveAutomatedPanel'

const _handleExport = async (path, params) => {
  const { filters, startedNotificationText, pendingNotificationText } = params

  if (startedNotificationText)
    addNotification({ message: startedNotificationText })
  if (pendingNotificationText)
    addNotification({ message: pendingNotificationText })

  await synapse.fetch(
    `${BASE_URL}/${path}`,
    { method: filters ? 'POST' : 'GET' },
    filters
  )
}

const createExportApiInstance = () => {
  const _private = {
    language: null
  }
  return {
    setLanguage(lang) {
      _private.language = lang
    },
    exportInstance(params) {
      const { instanceId, fileFormat } = params

      const queryParams = compact([
        `lng=${_private.language}`,
        fileFormat && `type=${fileFormat}`
      ]).join('&')

      saveAutomatedPanelInfo('EXPORT', {
        instance: instanceId
      })
      _handleExport(`instances/${instanceId}/export?${queryParams}`, params)
    },
    exportWorkingTableGroup(params) {
      const { wtGroup, instanceId, fileFormat } = params

      const queryParams = compact([
        `group=${wtGroup}`,
        `lng=${_private.language}`,
        fileFormat && `type=${fileFormat}`
      ]).join('&')

      saveAutomatedPanelInfo('EXPORT', {
        instance: instanceId,
        group: wtGroup
      })
      _handleExport(`instances/${instanceId}/export?${queryParams}`, params)
    },
    exportWorkingTable(params) {
      const { wtId, fileFormat } = params

      const queryParams = compact([
        `lng=${_private.language}`,
        fileFormat && `type=${fileFormat}`
      ]).join('&')

      saveAutomatedPanelInfo('EXPORT', {
        wt: wtId
      })
      _handleExport(`workingtables/${wtId}/export?${queryParams}`, params)
    },
    exportDocumentsByType(params) {
      const { wtType, wtId, fileFormat } = params

      const queryParams = compact([
        `lng=${_private.language}`,
        fileFormat && `type=${fileFormat}`
      ]).join('&')

      saveAutomatedPanelInfo('EXPORT', {
        wt: wtId,
        documentType: wtType
      })

      _handleExport(
        `workingtables/${wtId}/${wtType}/export?${queryParams}`,
        params
      )
    },
    // Export the entire document or a specific document field
    exportDocument(params) {
      const { field, wtType, wtId, documentId, fileFormat } = params
      const payloadNotification = {
        documentType: wtType,
        wt: wtId,
        documentId
      }

      if (field) {
        payloadNotification.item = field
      }

      saveAutomatedPanelInfo('EXPORT', payloadNotification)

      const queryParams = compact([
        field && `item=${field}`,
        `lng=${_private.language}`,
        fileFormat && `type=${fileFormat}`
      ]).join('&')

      _handleExport(
        `${wtType}/export/${wtId}/${documentId}?${queryParams}`,
        params
      )
    }
  }
}

export const ExportApi = createExportApiInstance()
